import { createSvgIcon } from '@mui/material';

const TimesheetHealthCheckIcon = createSvgIcon(
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 2C2 1.44772 2.44772 1 3 1H8V2H3V14H11V9H12V14C12 14.5523 11.5523 15 11 15H3C2.44772 15 2 14.5523 2 14V2Z"
      fill="currentColor"
    />
    <path d="M4 4H9V5H4V4Z" fill="currentColor" />
    <path d="M4 7H7V8H4V7Z" fill="currentColor" />
    <path d="M4 10H6V11H4V10Z" fill="currentColor" />
    <circle
      cx="12"
      cy="5"
      r="3.5"
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
    />
    <path
      d="M10.5 5L11.5 6L13.5 4"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>,
  'TimesheetHealthCheckIcon',
);

export default TimesheetHealthCheckIcon;
